var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { Animate } from "../Animate";
import Debounce from "debounce-decorator";
/**
 * Default duration
 */
var duration = 250;
/**
 * Default easing
 */
var easing = "ease";
/**
 * Higher order pass-through component. Implements {Animate} from core library.
 *
 * @property {trigger} JSX.Element
 * @property {content} JSX.Element
 * @property {link} String Optional property that defines unique link between few Expand/Collapse instances
 * @property {expandSpeed} Number Defines the expand speed of the container, defaults to {duration}
 * @property {collapseSpeed} Number Defines the collapse speed of the container, defaults to {expandSpeed} / 1.65
 * @property {easing} String | Number[] CSS3's named easings: "ease", "ease-in", "ease-out", and "ease-in-out". CSS3's bezier curves: Pass a four-item array of bezier points. Spring physics: Pass a two-item array in the form of [ tension, friction ]. A higher tension (default: 500) increases total speed and bounciness. A lower friction (default: 20) increases ending vibration speed. Step easing: Pass a one-item array in the form of [ steps ]. The animation will jump toward its end values using the specified number of steps.
 * @property {initiallyExpanded} Boolean Defines a default behaviour - whether the element should be expanded/collapsed when the component mounts to the DOM
 * @property {onBegin} Function An optional callback that will be called when the collapsible animation begins
 * @property {onComplete} Function An optional callback that will be called when the collaspisble animation completes
 *
 */
/* EXAMPLE USAGE:
*
   <Collapsible link="testLink"
       trigger={
           <h2>
               LINKED Some content and <a href="#" data-collapsible-non-trigger="true">non trigger element</a>
           </h2>
       }
       content={
           <div>
               some content <br /> some content <br /> some content
               <br /> some content
               <br /> some content <br /> some content
               <br /> some content <br /> some content <br /> some content
               <br /> some content <br /> some content
               <br /> some content
               <br /> some content <br /> some content <br /> some content
               <br /> some content
           </div>
       }
   />
   <Collapsible link="testLink"
       trigger={
           <h2>
               LINKED Some content and <a href="#" data-collapsible-non-trigger="true">non trigger element</a>
           </h2>
       }
       content={
           <div>
               some content <br /> some content <br /> some content
               <br /> some content
               <br /> some content <br /> some content
               <br /> some content <br /> some content <br /> some content
               <br /> some content <br /> some content
               <br /> some content
               <br /> some content <br /> some content <br /> some content
               <br /> some content
           </div>
       }
   />
   <Collapsible
       trigger={
           <h2>
               Some content and <a href="#" data-collapsible-non-trigger="true">non trigger element</a>
           </h2>
       }
       content={
           <div>
               some content <br /> some content <br /> some content
               <br /> some content
               <br /> some content <br /> some content
               <br /> some content <br /> some content <br /> some content
               <br /> some content <br /> some content
               <br /> some content
               <br /> some content <br /> some content <br /> some content
               <br /> some content
           </div>
       }
   />
*/
var Collapsible = /** @class */ (function (_super) {
    __extends(Collapsible, _super);
    /**
     * @constructor
     */
    function Collapsible(props) {
        var _this = _super.call(this, props) || this;
        _this.animCollapse = {
            animation: { height: 0 },
            duration: _this.props.collapseSpeed || duration / 1.65,
            easing: _this.props.easing || easing,
            begin: function (elements) {
                // TODO: Check if we can test this one
                /* istanbul ignore next */
                typeof props.onBegin === "function" &&
                    props.onBegin(elements, _this);
            },
            complete: function (elements) {
                // TODO: Check if we can test this one
                /* istanbul ignore next */
                typeof props.onComplete === "function" &&
                    props.onComplete(elements, _this);
            }
        };
        _this.animExpand = __assign({}, _this.animCollapse, { duration: _this.props.expandSpeed || duration });
        _this.state = {
            anim: _this.props.initiallyExpanded ? _this.animExpand : _this.animCollapse,
            contentHeight: 0
        };
        _this.block = null;
        _this.trigger = null;
        _this.content = null;
        return _this;
    }
    /**
     * Returns if the content is collapsed. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Collapsible.prototype.isCollapsed = function () {
        return this.trigger && (this.trigger.dataset.collapsed === "true");
    };
    /**
     * Fires toggle() Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Collapsible.prototype.onClick = function (e) {
        if (!(e && e.target && e.target["dataset"].collapsibleNonTrigger === "true")) {
            this.toggle();
        }
        return this;
    };
    /**
     * Returns the height of the content. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Collapsible.prototype.getContentHeight = function () {
        return this.content && this.content.getBoundingClientRect().height;
    };
    /**
     * Check if there multiple siblings of this kind and closes all of them. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Collapsible.prototype.collapseLinked = function () {
        var link = this.trigger && this.trigger.dataset.collapsibleLink;
        if (link !== undefined) {
            Array.prototype.forEach.call(document.querySelectorAll("[data-collapsible-link=\"" + link + "\""), function (x) {
                typeof x.collapse === "function" && x.collapse();
            });
        }
    };
    /**
     * Fires expand animation. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Collapsible.prototype.expand = function () {
        var contentHeight = this.getContentHeight() || 0;
        this.collapseLinked();
        this.trigger && (this.trigger.dataset.collapsed = "false");
        this.setState({
            anim: __assign({}, this.animExpand, { animation: { height: contentHeight } }),
            contentHeight: contentHeight
        });
        return this;
    };
    /**
     * Fires collapse animation. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Collapsible.prototype.collapse = function () {
        this.trigger && (this.trigger.dataset.collapsed = "true");
        this.setState({
            anim: this.animCollapse,
            contentHeight: 0
        });
        return this;
    };
    /**
     * Toggles between expand/collapse. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Collapsible.prototype.toggle = function () {
        /* istanbul ignore next */
        return this[this.isCollapsed() ? "expand" : "collapse"]();
    };
    /**
     * Attaches hooks for external scripts. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Collapsible.prototype.componentDidMount = function () {
        if (this.trigger) {
            this.trigger["expand"] = this.expand.bind(this);
            this.trigger["toggle"] = this.toggle.bind(this);
            this.trigger["collapse"] = this.collapse.bind(this);
            this.props.initiallyExpanded && this.expand();
        }
    };
    /**
     * Debounced manual update. If content size changes we will expand/contract the container to accomodate the update. Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Collapsible.prototype.updateExpand = function () {
        if (!this.isCollapsed()) {
            this.expand();
        }
    };
    /**
     * Ignored during code coverage tests as it requires browser testing.
     */
    /* istanbul ignore next */
    Collapsible.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.getContentHeight() !== prevState.contentHeight) {
            this.updateExpand();
        }
    };
    Collapsible.prototype.render = function () {
        var _this = this;
        return (React.createElement("sb-collapsible", null,
            React.createElement("sb-collapsible-trigger", { "data-collapsible-link": this.props.link, "data-collapsed": "true", ref: function (n) { return _this.trigger = n; }, onClick: this.onClick.bind(this) }, this.props.trigger),
            React.createElement(Animate, __assign({}, this.state.anim),
                React.createElement("sb-collapsible-block", { "data-collapsible-block": true, ref: function (n) { return _this.block = n; } },
                    React.createElement("sb-collapsible-content", { ref: function (n) { return _this.content = n; } }, this.props.content)))));
    };
    __decorate([
        Debounce(50),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Collapsible.prototype, "updateExpand", null);
    return Collapsible;
}(React.Component));
export { Collapsible };
/**
 * EXAMPLE USAGE:
 *
    <Collapsible link="testLink"
        trigger={
            <h2>
                LINKED Some content and <a href="#" data-collapsible-non-trigger="true">non trigger element</a>
            </h2>
        }
        content={
            <div>
                some content <br /> some content <br /> some content
                <br /> some content
                <br /> some content <br /> some content
                <br /> some content <br /> some content <br /> some content
                <br /> some content <br /> some content
                <br /> some content
                <br /> some content <br /> some content <br /> some content
                <br /> some content
            </div>
        }
    />
    <Collapsible link="testLink"
        trigger={
            <h2>
                LINKED Some content and <a href="#" data-collapsible-non-trigger="true">non trigger element</a>
            </h2>
        }
        content={
            <div>
                some content <br /> some content <br /> some content
                <br /> some content
                <br /> some content <br /> some content
                <br /> some content <br /> some content <br /> some content
                <br /> some content <br /> some content
                <br /> some content
                <br /> some content <br /> some content <br /> some content
                <br /> some content
            </div>
        }
    />
    <Collapsible
        trigger={
            <h2>
                Some content and <a href="#" data-collapsible-non-trigger="true">non trigger element</a>
            </h2>
        }
        content={
            <div>
                some content <br /> some content <br /> some content
                <br /> some content
                <br /> some content <br /> some content
                <br /> some content <br /> some content <br /> some content
                <br /> some content <br /> some content
                <br /> some content
                <br /> some content <br /> some content <br /> some content
                <br /> some content
            </div>
        }
    />
*/ 
//# sourceMappingURL=Collapsible.js.map